export const toolRefs:{[key:string]:any} = {
    'Rebar Gun': {
        image: 'Tools/RebarGun_256.png'
    },
    'Detonator': {
        image: 'Tools/Detonator_256.png'
    },
    'Gas Mask': {
        image: 'Tools/GasMask_256.png'
    },
    'Hard Drive': {
        image: 'Tools/HardDrive_256.png'
    },
    'Chainsaw': {
        image: 'Tools/IconDesc_Chainsaw_256.png'
    },
    'Coffee Cup': {
        image: 'Tools/IconDesc_CoffeeCup_256.png'
    },
    'Xenobasher': {
        image: 'Tools/ShockBaton_256.png'
    },
    'Berry': {
        image: 'Tools/IconDesc_Berry_256.png'
    },
    'Boombox': {
        image: 'Tools/IconDesc_Boombox_256.png'
    },
    'Golden Coffee Cup': {
        image: 'Tools/IconDesc_CupGold_256.png'
    },
    'Golf Cart': {
        image: 'Tools/IconDesc_GolfCart_256.png'
    },
    'Golden Golf Cart': {
        image: 'Tools/IconDesc_GolfCartGold_256.png'
    },
    'HatcherPart': {
        image: 'Tools/IconDesc_HatcherPart_256.png'
    },
    'Hub Parts': {
        image: 'Tools/IconDesc_HubParts_256.png'
    },
    'Hazmat Suit': {
        image: 'Tools/IconDesc_HazmatSuit_256.png'
    },
    'Hog Part': {
        image: 'Tools/IconDesc_HogPart_256.png'
    },
    'Hoverpack': {
        image: 'Tools/IconDesc_Hoverpack_256.png'
    },
    'Blade Runners': {
        image: 'Tools/IconDesc_SprintingStilts_256.png'
    },
    'Stinger Parts': {
        image: 'Tools/IconDesc_StingerPart_256.png'
    },
    'Xeno Zapper': {
        image: 'Tools/IconDesc_XenoZapper_256.png'
    },
    'Zipline': {
        image: 'Tools/IconDesc_Zipline_256.png'
    },
    'Inhaler': {
        image: 'Tools/Inhaler_256.png'
    },
    'Jetpack': {
        image: 'Tools/Jetpack_256.png'
    },
    'Nut': {
        image: 'Tools/Nut_256_New.png'
    },
    'Object Scanner': {
        image: 'Tools/ObjectScanner_256.png'
    },
    'Parachute': {
        image: 'Tools/Parachute_256.png'
    },
    'Portable Miner': {
        image: 'Tools/PortableMiner_256.png'
    },
    'Rifle': {
        image: 'Tools/RifleMk1_256.png'
    },
    'WIP1': {
        image: 'Tools/Wat_1_256.png'
    },
    'WIP2': {
        image: 'Tools/Wat_2_256.png'
    }

}